import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type EnterpriseProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const Enterprise = ({ size = 24, width, height, alt = '', style, ...props }: EnterpriseProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'rect',
        {
          width: '24',
          height: '24',
          rx: '4',
          fill: 'url(#paint0_linear_722_9574)',
        },
      ),
      h(
        'rect',
        {
          x: '0.25',
          y: '0.25',
          width: '23.5',
          height: '23.5',
          rx: '3.75',
          stroke: 'url(#paint1_linear_722_9574)',
          "stroke-opacity": '0.3',
          "stroke-width": '0.5',
          "stroke-linecap": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M11.7118 5.03487C11.9245 4.98818 12.0745 4.98824 12.287 5.03487C12.5013 5.08196 12.751 5.23125 13.2489 5.52999C14.3447 6.18737 15.5071 6.75363 16.7118 7.1755C17.2779 7.37373 17.5608 7.47301 17.7558 7.64327C17.9229 7.7893 18.0616 7.99103 18.1366 8.19991C18.224 8.44342 18.2158 8.67244 18.1991 9.1296C18.1517 10.4315 17.9164 12.3667 17.0575 14.113C15.925 16.4158 14.0329 17.9265 12.912 18.6706C12.6662 18.8338 12.5432 18.916 12.3114 18.9714C12.1509 19.0097 11.8492 19.0096 11.6884 18.9714C11.4566 18.916 11.3328 18.8339 11.0868 18.6706C9.96595 17.9265 8.07486 16.4156 6.9423 14.113C6.08349 12.3667 5.84816 10.4315 5.8007 9.1296C5.78404 8.6724 5.7758 8.44344 5.8632 8.19991C5.93817 7.99118 6.07609 7.78926 6.24308 7.64327C6.43804 7.47299 6.7218 7.37377 7.288 7.1755C8.49266 6.75362 9.65515 6.18735 10.7509 5.52999C11.2487 5.23137 11.4976 5.08196 11.7118 5.03487ZM10.4482 14.2732C10.224 14.2732 10.0538 14.475 10.0917 14.696C10.1216 14.8695 10.2721 14.9968 10.4482 14.9968H13.5546C13.7304 14.9964 13.8813 14.8693 13.9111 14.696C13.9488 14.4754 13.7783 14.2736 13.5546 14.2732H10.4482ZM11.9999 8.9919C11.6771 8.992 11.4159 9.25405 11.4159 9.57687C11.4161 9.83093 11.5781 10.0472 11.8046 10.1276L11.0976 12.0358C11.0529 12.1566 10.8941 12.183 10.8124 12.0837L9.32121 10.2566C9.43082 10.1503 9.49886 10.0013 9.49894 9.83663C9.49894 9.51403 9.23745 9.25212 8.91496 9.25167C8.59208 9.25167 8.33 9.51376 8.33 9.83663C8.33015 10.1594 8.59218 10.4206 8.91496 10.4206C8.94833 10.4206 8.98175 10.4182 9.01359 10.4128L9.88957 13.529C9.95031 13.7448 10.1478 13.8942 10.372 13.8942H13.6298C13.8538 13.8939 14.0507 13.7447 14.1112 13.529L14.9872 10.4128C15.019 10.4182 15.0525 10.4206 15.0859 10.4206C15.4083 10.4202 15.6697 10.1591 15.6698 9.83663C15.6698 9.51402 15.4084 9.25209 15.0859 9.25167C14.763 9.25167 14.5009 9.51376 14.5009 9.83663C14.501 10.0016 14.5697 10.1503 14.6796 10.2566L13.1894 12.0837C13.1079 12.1836 12.9482 12.1567 12.9032 12.0358L12.1962 10.1276C12.4223 10.047 12.5847 9.83066 12.5849 9.57687C12.5849 9.25415 12.3226 8.99217 11.9999 8.9919Z',
          fill: 'url(#paint2_linear_722_9574)',
        },
      ),
      h(
        'defs',
        {
        },
        [
          h(
            'linearGradient',
            {
              id: 'paint0_linear_722_9574',
              x1: '-18.2374',
              y1: '-57.7414',
              x2: '66.435',
              y2: '-60.9184',
              gradientUnits: 'userSpaceOnUse',
            },
            [
              h(
                'stop',
                {
                  offset: '1',
                  "stop-color": '#C7B0F7',
                  "stop-opacity": '0.3',
                },
              ),
            ],
          ),
          h(
            'linearGradient',
            {
              id: 'paint1_linear_722_9574',
              x1: '-0.503001',
              y1: '6.71775',
              x2: '24.8358',
              y2: '7.15595',
              gradientUnits: 'userSpaceOnUse',
            },
            [
              h(
                'stop',
                {
                  offset: '1',
                  "stop-color": '#BA89F9',
                },
              ),
            ],
          ),
          h(
            'linearGradient',
            {
              id: 'paint2_linear_722_9574',
              x1: '18.2096',
              y1: '3.95226',
              x2: '7.04184',
              y2: '20.271',
              gradientUnits: 'userSpaceOnUse',
            },
            [
              h(
                'stop',
                {
                  "stop-color": '#B767FD',
                },
              ),
              h(
                'stop',
                {
                  offset: '1',
                  "stop-color": '#472497',
                },
              ),
            ],
          ),
        ],
      ),
    ],
  );

export default Enterprise;
